import React, { useState } from "react";
import Button from "components/Button/Button";
import FormInput from "components/Inputs/FormInput";
import { t } from "i18next";
import Select from "react-select";
import { RssService } from "service/rss.service";

export const RssForm = ({ postData }: any) => {
	const [rssUrlLoading, setRssUrlLoading] = useState(false);
	const [errorMsg, setErrorMsg] = useState("");
	const defaultValue: any[] = [];

	const [formData, setFormData] = useState<any[]>(defaultValue);
	const [selectedFeeds, setSelectedFeeds] = useState<any[]>([]);
	const onSubmit = (e: any) => {
		e.preventDefault();
		postData(formData);
	};
	const searchFeedsFromUrl = async (value: string) => {
		setFormData(defaultValue);
		setSelectedFeeds([]);
		setErrorMsg("");
		const UrlRegEx =
			/(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi;
		const regex = new RegExp(UrlRegEx);
		if (value.match(regex)) {
			setRssUrlLoading(true);
			try {
				const data = await RssService.getFeedsFromUrl(value);
				const feeds = Object.keys(data).map((key) => ({
					label: key,
					value: (data as any)[key],
				}));
				setSelectedFeeds(feeds);
				setRssUrlLoading(false);
			} catch (error) {
				setErrorMsg(t("Rss.ERROR_MSG") as string);
				setRssUrlLoading(false);
			}
		}
	};
	const onChange = (arr: any[]) => {
		const formatArr = arr.map((item: any) => ({
			name: item.label.substring(0, 25),
			url: item.value,
			isNotified: item.isNotified,
		}));
		setFormData([...formatArr]);
	};
	const updateFormData = (index: number, key: string, value: any) => {
		const updatedFormData = [...formData];
		updatedFormData[index] = {
			...updatedFormData[index],
			[key]: value,
		};
		setFormData(updatedFormData);
	};
	return (
		<div className="panel-form">
			<form onSubmit={onSubmit}>
				<FormInput
					type="text"
					className="mb-2"
					placeholder={t("Rss.SEARCH_RSS_FEEDS") as string}
					onChange={(value: string) => searchFeedsFromUrl(value)}
				/>
				{errorMsg && <div className="text-center">{errorMsg}</div>}

				{rssUrlLoading ? (
					<div className="text-center">{t('Commons.LOADING')}</div>
				) : (
					<>
						{selectedFeeds.length > 0 && (
							<>
								{selectedFeeds.length > 0 && (
									<Select
										placeholder={t("Rss.SELECT_RSS_FEEDS") as string}
										className="mb-2 panel-form-dropdown"
										classNamePrefix="dropdown"
										options={selectedFeeds}
										onChange={onChange as any}
										isMulti={true}
									/>
								)}
								{formData.map((item, index) => (
									<React.Fragment key={index}>
										<div className="form-input">
											<input
												type="text"
												value={item.name || ''}
												className="mb-2 w-100"
												placeholder={t("Rss.RSS_NAME") as string}
												maxLength={25}
												onChange={(e) =>
													updateFormData(
														index,
														"name",
														e.target.value
													)
												}
											/>
										</div>

										<div className="form-checkbox mb-2">
											<FormInput
												id="notify"
												type="checkbox"
												onClick={(e: any) =>
													updateFormData(
														index,
														"isNotified",
														e.target.checked
													)
												}
											/>
											<label
												className="text-checkbox"
												htmlFor="notify"
											>
												{t("Rss.NOTIFY")}
											</label>
										</div>
									</React.Fragment>
								))}

								<Button
									className="panel-form-btn"
									type="submit"
								>
									{t("Rss.SUBMIT")}
								</Button>
							</>
						)}
					</>
				)}
			</form>
		</div>
	);
};
